import DaoBase from "./base";

class DaoBBSFile extends DaoBase {
    bbs_fileid;
    bbsid;
    filename;
    filesize;
    order;
    url;

    constructor(json=null) {
        super(json);
    }
}

export default DaoBBSFile;


// WEBPACK FOOTER //
// ./src/modules/dao/bbs.file.js